/**
 * A component to search
 *
 * @param header the heading of the element
 * @param value the value of the element
 * @param isBox whether to format the value in a box, e.g. for a status
 * @param formatString the format of the text you would like
 * @param formatType the type of text to format, i.e. currency, date
 */
export const DetailFormatter: ng.IComponentOptions = {
  bindings: {
    header: '@',
    value: '@',
    isBox: '@',
    formatString: '@',
    formatType: '@'
  },
  templateUrl: 'app/angularJS/components/detail-formatter/detail-formatter.html',
  controller: 'DetailFormatterController',
  controllerAs: 'vm'
};